export default {
  "pl": {
    "toast": {
      "action": {
        "failed": "Wystąpił nieoczekiwany błąd.",
        "impersonate_unauthorized": "Nie możesz wykonać tego działania podczas korzystania z widoku roli klienta."
      },
      "create": {
        "failed": "Nie udało się utworzyć elementu: {itemName}",
        "succeeded": "Utworzono element: {itemName}"
      },
      "delete": {
        "failed": "Nie udało się usunąć elementu: {itemName}",
        "succeeded": "Usunięto element: {itemName}",
        "succeeded_default": "Usuwanie powiodło się"
      },
      "update": {
        "failed": "Nie udało się zaktualizować elementu: {itemName}",
        "succeeded": "Zaktualizowano element: {itemName}"
      },
      "upload": {
        "failed": "Przesyłanie nie powiodło się",
        "succeeded": "Przesyłanie powiodło się"
      },
      "upload_document": {
        "extension_invalid": "Dokument {document_name} ma nieprawidłowe rozszerzenie."
      },
      "upload_image": {
        "file_too_big": "Plik za duży: maksymalny rozmiar pliku to 5 MB"
      },
      "warning": {
        "multipleFiles": "Ten eksport obejmuje wiele plików ZIP. Twoja przeglądarka może blokować jednoczesne pobieranie wielu plików. Jeśli udało ci się pobrać tylko 1 plik ZIP, skontaktuj się z zespołem pomocy Ziggu."
      }
    }
  }
}
